import 'script-loader!jquery/dist/jquery.min'
